<template>
    <router-view />
</template>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');
@import '~/node_modules/destyle.css/destyle.min.css';
@import '@/assets/sass/_common.scss';
</style>
